import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Container } from "../../components/Container/Container";
import Button from '../../components/Button/Button';
import TextField from '../../components/TextField/TextField';
import { getRegisterInfo, resetPasswordSecondStep } from '../../store/auth/actions';
import i18n from "i18next";
import { validatePass } from "../../services/utils";
import Svg from "../../../src/assets/icons/icons"
import { H4 } from "../../styles/typography/typography"
import {
    InputWrapStyled,
    InputIconWrapStyled,
    RowStyled,
    ErrorStyled,
    ErrorBlockStyled,
} from "../../components/LogIn/style";

import { ContainerCatalogStyled } from "../../components/Container/style";

import {
    FormSt,
    PopupLoginSt,
    ContentSt,
    TabContainerSt,
    ButtonWrapStyled,
    InfoFormStyled,
    TitleResetSt,
} from "./style";


const initialState = {
    isShowPass: false,
    isShowConfirmPass: false,
    newPassword: "",
    confirmPassword: "",
    formErrors: { newPassword: "", confirmPassword: "", },
    loading: false
};

// валидация поля формы, возвращает новое состояние
const applyFieldValidation = (state, fieldName, value) => {
    const fieldValidationErrors = { ...state.formErrors };
    let newPasswordValid = state.newPasswordValid;
    let confirmPasswordValid = state.confirmPasswordValid;

    switch (fieldName) {
        case 'newPassword':
            newPasswordValid = validatePass(value);
            fieldValidationErrors.newPassword = (!value) ? i18n.t(`login.fill_in_the_field`) : newPasswordValid ? "" : i18n.t(`login.password_length_less_than_8_characters`);
            break;
        case 'confirmPassword':
            if (state.newPassword && state.newPassword === state.confirmPassword) {
                if (!validatePass(value)) {
                    confirmPasswordValid = false
                    fieldValidationErrors.newPassword = i18n.t(`login.password_length_less_than_8_characters`) //Длина пароля менее 8 символов
                }
            }
            else {
                fieldValidationErrors.confirmPassword = i18n.t(`login.passwords_do_not_match`) //Пароли не совпадают
                confirmPasswordValid = false
            }
            if (state.newPassword === state.confirmPassword) {
                fieldValidationErrors.confirmPassword = ""
                confirmPasswordValid = true
            }
            break;
        default:
            break;
    }

    return {
        ...state,
        formErrors: fieldValidationErrors,
        newPasswordValid,
        confirmPasswordValid,
    };
};

const PasswordReset = () => {
    const [state, setState] = useState(initialState);

    const dispatch = useDispatch();
    const message = useSelector((store) => store.auth.message);
    const errors = useSelector((store) => store.auth.errors);
    const location = useLocation();

    // componentDidMount
    useEffect(() => {
        dispatch(getRegisterInfo());
    }, [dispatch]);

    const updateState = (patch) => {
        setState((prev) => ({ ...prev, ...(typeof patch === "function" ? patch(prev) : patch) }));
    };

    // ввод данных в инпуты
    const handleFieldChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setState((prev) => applyFieldValidation({ ...prev, [name]: value }, name, value));
    };

    // валидация формы по кнопке отправить
    const validatePassRecovery = () => {
        const isValidatePass = validatePass(state.newPassword);
        let newPassword = "";
        let confirmPassword = "";

        if (!state.newPassword) {
            newPassword = i18n.t(`login.fill_in_the_field`) //Заполните поле
        }
        if (state.newPassword && !isValidatePass) {
            newPassword = i18n.t(`login.password_length_less_than_8_characters`) //Длина пароля менее 8 символов
            //Пароль должен содержать не менее 8 символов и не менее одной цифры
        }

        if (state.newPassword && state.newPassword === state.confirmPassword) {
            if (!isValidatePass) {
                newPassword = i18n.t(`login.password_length_less_than_8_characters`) //Длина пароля менее 8 символов
            }
        }
        else {
            confirmPassword = i18n.t(`login.passwords_do_not_match`) //Пароли не совпадают
        }

        if (newPassword || confirmPassword) {
            updateState({ formErrors: { newPassword, confirmPassword } });
            return false
        }

        return true
    };

    // отправка данных
    const handlePassRecoverySubmit = (e) => {
        const email = location.search.replace(/\?email=/, "").replace(/%40/, "@");
        const token = location.pathname.replace(/\/password\/reset\//, "");
        e.preventDefault();
        const isValid = validatePassRecovery();
        if (isValid) {
            updateState({ formErrors: { newPassword: "", confirmPassword: "" } });
            dispatch(resetPasswordSecondStep(token, email, state.newPassword, state.confirmPassword));
        }
        else {
            updateState({ loading: false });
        }
    };

    const serverErrors = Object.values(errors)

    const classNameForInput = state.newPasswordValid
        ? "valid"
        : state.formErrors.newPassword
            ? "invalid" : ""

    const classNameForConfirmPassInput = state.confirmPasswordValid
        ? "valid"
        : state.formErrors.confirmPassword
            ? "invalid" : ""

    return (
        <ContainerCatalogStyled style={{ paddingTop: "100px" }}>
            <Container>
                <PopupLoginSt>
                    <TabContainerSt>
                        <ContentSt>
                            <FormSt
                                onSubmit={(e) => handlePassRecoverySubmit(e)}
                                action="#" method="post"
                            >
                                <TitleResetSt>
                                    <H4>{i18n.t(`password-recovery.title`)}</H4>
                                    <InfoFormStyled>{i18n.t(`password-recovery.second_title`)}</InfoFormStyled>
                                </TitleResetSt>

                                <RowStyled>
                                    <InputWrapStyled>
                                        <TextField
                                            handleFieldChange={(e) => handleFieldChange(e)}
                                            error={state.formErrors.newPassword}
                                            className={classNameForInput}
                                            type={state.isShowPass ? "text" : "password"}
                                            name="newPassword"
                                            placeholder={i18n.t(`password-recovery.new_password`)}
                                        />
                                        <InputIconWrapStyled onClick={() => updateState((prev) => ({ isShowPass: !prev.isShowPass }))}>
                                            <Svg type={state.isShowPass ? "visibility" : "visibility_off"} />
                                        </InputIconWrapStyled>
                                    </InputWrapStyled>
                                </RowStyled>

                                <RowStyled>
                                    <InputWrapStyled>
                                        <TextField
                                            handleFieldChange={(e) => handleFieldChange(e)}
                                            error={state.formErrors.confirmPassword}
                                            className={classNameForConfirmPassInput}
                                            type={state.isShowConfirmPass ? "text" : "password"}
                                            name="confirmPassword"
                                            placeholder={i18n.t(`password-recovery.confirm_password`)}
                                        />
                                        <InputIconWrapStyled onClick={() => updateState((prev) => ({ isShowConfirmPass: !prev.isShowConfirmPass }))}>
                                            <Svg type={state.isShowConfirmPass ? "visibility" : "visibility_off"} />
                                        </InputIconWrapStyled>
                                    </InputWrapStyled>
                                </RowStyled>
                                <ButtonWrapStyled>
                                    <Button as="a" href="/" label={i18n.t(`password-recovery.button`)} size="big" type="submit" width="100%" />
                                </ButtonWrapStyled>
                                {/* Здесь сообщение об ошибке */}
                                <ErrorBlockStyled style={{ width: '100%' }}>
                                    <ErrorStyled> {message}</ErrorStyled>
                                    {serverErrors.map((item, i) => (
                                        <ErrorStyled key={i}> {item}</ErrorStyled>
                                    ))}
                                </ErrorBlockStyled>
                            </FormSt>
                        </ContentSt>
                    </TabContainerSt>
                </PopupLoginSt>
            </Container>
        </ContainerCatalogStyled>
    )
};

export default PasswordReset;
